// extracted by mini-css-extract-plugin
export default {"wrapper":"MainSidebar_wrapper__pvpoT","logo-link":"MainSidebar_logo-link__ob5-S","shrank":"MainSidebar_shrank__ckzhH"};